// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulputpp{gap:var(--ds-space-150,9pt)}._19bvv77o{padding-left:var(--ds-space-025,2px)}\n._1bah1h6o{justify-content:center}\n._1bsbzwfg{width:2pc}\n._1e0c1txw{display:flex}\n._2hwx1b66{margin-right:var(--ds-space-050,4px)}\n._4cvr1h6o{align-items:center}\n._4t3i1tcg{height:24px}\n._ca0qv77o{padding-top:var(--ds-space-025,2px)}\n._n3tdv77o{padding-bottom:var(--ds-space-025,2px)}\n._u5f3v77o{padding-right:var(--ds-space-025,2px)}", ""]);
// Exports
module.exports = exports;
